import React from 'react';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import style from './style.scss';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {openPopupProductDetail} from 'actions';

class ItemProductOther extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.openPopupDetail = this.openPopupDetail.bind(this);
  }

  openPopupDetail() {
    this.props.dispatch(openPopupProductDetail(this.props.id));
  }

  render() {
    return (
      <section className="item-product-other">
        <div className='wrap-img' onClick={this.openPopupDetail}>
          <UploadImage transform="crop" type="PRODUCT" width="157" height="92" image={this.props.images[this.props.images.length -1]} />
        </div>
        <p className='product-name'>
          <Link to={`/san-pham/${this.props.nameSlug}/${this.props.id}`} className="product-link">{this.props.name}</Link>
        </p>
        <p className='product-type'>{this.props.type}</p>
        <p className='product-price'>Giá {this.props.price}</p>
      </section>
    );
  }
}

export default connect()(ItemProductOther);



// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product-other/ItemProductOther.jsx